import classnames from 'classnames'

import { MCP_LOGOS } from '../../common/mcpLogos'
import { ReactComponent as ZocksIcon } from '../../assets/images/ZocksIcon-primary.svg'

import styles from './McpLogoRow.module.scss'

const BADGE_CLASS_NAME = 'd-flex align-items-center justify-content-center rounded zocks-bg-color-gray-100'

interface McpLogoRowProps {
  className?: string
}

export const McpLogoRow: React.FC<McpLogoRowProps> = ({ className }) => (
  <div className={classnames('d-flex align-items-center gap-2', className)}>
    {MCP_LOGOS.map((logo) => (
      <span key={logo.alt} className={classnames(BADGE_CLASS_NAME, styles.badge)}>
        <img className={styles.logo} src={logo.src} alt={logo.alt} />
      </span>
    ))}
    <span aria-hidden='true' className={classnames('d-flex align-items-center zocks-gap-0.125', styles.overflow)}>
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
    </span>
    <span className={classnames(BADGE_CLASS_NAME, styles.badge)}>
      <ZocksIcon className={styles.logo} aria-label='Zocks' role='img' />
    </span>
  </div>
)
